interface DriverOffDutyScope {
  driverCompanyId?: string;
  driverIsShared: boolean;
  pickedCompanyId: string;
}

// The picked company can only set its own drivers or ones shared to it off duty; any other
// driver would 404. A driver with an unknown company is never blocked.
export function canSetDriverOffDuty({
  driverCompanyId,
  driverIsShared,
  pickedCompanyId,
}: DriverOffDutyScope): boolean {
  return !driverCompanyId || driverCompanyId === pickedCompanyId || driverIsShared;
}
